import _ from 'lodash'

import { DorothyUtils } from '@utils/DorothyUtils'
import { EnvironmentDetail } from '@amzn/ihm-associate-tools-js-lib'

const userTypeKey = 'USER_TYPE_KEY'
const isWfmKey = 'IS_WFM_KEY'

export class UserTypeService {
    private static _selectedUserType: String = undefined
    private static _isWfm: boolean = false

    public static getAvailableUserTypes () {
        const _primaryStoreId = EnvironmentDetail.getStoreId()
        const _availableUserTypes = _.uniq(DorothyUtils.getAvailableStores(_primaryStoreId)
            .map((store) => {
                return store.acceptedUserTypes
            })
            .reduce((accum, value) => {
                return accum.concat(value)
            }, [])
            .sort())

        console.log('ATBase: Dorothy available user types: ', _availableUserTypes)

        return _availableUserTypes as string[]
    }

    public static setUserType (userType) {
        // the buttons are populated dynamically according to available user types
        // this should never be true, but exists as a fallback error and for unit testing
        if (UserTypeService.getAvailableUserTypes().indexOf(userType) === -1) {
            throw new Error('Invalid user type')
            // InvalidUserTypeException('Invalid user type ' + userType + ' selected. ' +
            //     'Available user types: ' + _availableUserTypes.join(', '));
        }
        this._selectedUserType = userType
        window.sessionStorage.setItem(userTypeKey,userType)
    }

    public static getUserType () {
        if (this._selectedUserType === undefined && window.sessionStorage.getItem(userTypeKey)) {
            this.setUserType(window.sessionStorage.getItem(userTypeKey))
        }
        return this._selectedUserType
    }

    public static resetUserType () {
        window.sessionStorage.removeItem(userTypeKey)
        this._selectedUserType = undefined
    }

    // storing whether user logged in with WFM credentials for future logout redirection to Azure
    public static setIsWfmLoginTrue () {
        this._isWfm = true
        window.sessionStorage.setItem(isWfmKey, 'true')
    }

    public static resetIsWfmLogin () {
        window.sessionStorage.removeItem(isWfmKey)
        this._isWfm = false
    }

    public static getIsWfmLogin () {
        if (this._isWfm === false && window.sessionStorage.getItem(isWfmKey)) {
            this.setIsWfmLoginTrue()
        }
        return this._isWfm
    }
}
